import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.PROCESSO_UTILIZACAO.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.PROCESSO_UTILIZACAO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.PROCESSO_UTILIZACAO.LIMPAR_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},

	[mutationTypes.PROCESSO_UTILIZACAO.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.PROCESSO_UTILIZACAO.SET_INFORMACOES](state, informacoes) {
		state.informacoes = informacoes
	},

	[mutationTypes.PROCESSO_UTILIZACAO.RESET_INFORMACOES](state) {
		state.informacoes = { processo: {} }
	},
}
